<template>
  <div class="admin-container">
    <v-container fluid>
      <v-btn fab color="primary" v-if="!drawer" @click="drawer = true" class="drawer-open">
        <v-icon right>fa-angle-right</v-icon>
      </v-btn>
      <v-navigation-drawer absolute class="py-5" v-model="drawer">
        <v-list dense class="py-0">
          <v-list-item v-if="user.given_name">
            <p>Hello, {{ user.given_name }}!</p>
          </v-list-item>
          <v-list-item
            color="primary"
            v-for="(item, index) in collections"
            :key="index"
            link
            :to="{ path: `/admin/${index}`}"
            active-class="active"
            class="px-10"
          >
            <v-list-item-icon>
              <v-icon color="primary">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <template v-slot:append>
          <div v-if="$route.params.id">
            <v-btn color="primary" block depressed tile @click="$router.back()">Back</v-btn>
          </div>
          <div>
            <v-btn color="primary" block depressed tile @click="onLogoutClick()">Logout</v-btn>
          </div>
        </template>
      </v-navigation-drawer>
      <v-row class="py-0">
        <v-col class="collection-view py-0">
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import collections from '@/mixins/collections'

export default {
  name: 'Admin',
  mixins: [collections],
  data () {
    return {
      drawer: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  mounted () {
    const initCollection = Object.keys(this.collections)[0]
    if (initCollection && !this.$route.params.collection) {
      this.$router.push({ path: `/admin/${initCollection}` })
    }
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    onLogoutClick () {
      this.logout()
    }
  }
}
</script>

<style scoped lang="scss">
.admin-container {
  position: relative;

  & > .container {
    height: 100%;
    padding: 0;
  }
}

.v-navigation-drawer {
  .row {
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) padding-left;
  }

  &--open ~ .row {
    padding-left: 256px;
  }

  .v-list-item {
    text-transform: capitalize;

    &:hover {
      text-decoration: none;
    }

    &.active {
      background-color: var(--v-primary-base);

      .v-list-item__title,
      .v-icon {
        color: white !important;
      }
    }

    .v-list-item__title {
      color: var(--v-primary-base);
    }
  }
}

.drawer-open {
  position: absolute;
  top: 10px;
  left: -25px;
  z-index: 99;
}
</style>
